module.exports = __webpack_public_path__ + "static/assets/25c294b62fe9e614db125a4f65cc6044.mp3";